import { createAsyncThunk } from '@reduxjs/toolkit';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import { GlobalState } from '../../reducers';
import types from './types';

type GPSLocationAPIPayload = {
  latitude: number;
  longitude: number;
}

const submitGPSLocation = createAsyncThunk(
  types.SUBMIT_GPS_LOCATION,
  async (payload: GPSLocationAPIPayload, { dispatch, getState, rejectWithValue }) => {
    try {
      const state = getState() as GlobalState;
      // TODO: Fix typing once the sessionReducer is typed
      const device: any = state.apps.manual.session.get('device'); // eslint-disable-line @typescript-eslint/no-explicit-any

      const updatedLocation: GPSLocationAPIPayload = await device.setGps(
        payload.latitude,
        payload.longitude,
      );

      dispatch(notificationActions.notifySuccess(
        `GPS successfully set to ${updatedLocation.latitude}, ${updatedLocation.longitude}.`,
        undefined,
        false,
        undefined,
        true,
      ));

      return updatedLocation;
    } catch (error) {
      dispatch(notificationActions.notifyError(
        `Setting the GPS failed: ${(error as Error).toString()}.`,
        undefined,
        true,
        undefined,
        true,
      ));
      return rejectWithValue(error);
    }
  },
);

export default {
  submitGPSLocation,
};

export type {
  GPSLocationAPIPayload,
};
